import { useEffect, useState } from 'react';

// Returns `value` delayed until it stops changing for `delayMs` — used to
// throttle search input before it drives a server query.
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
};
